<template>
    <div class="fadeup-group">
        <div ref="slider" class="keen-slider fadeup">
            <div
                class="keen-slider__slide p-4"
                v-for="(product, index) in products"
                v-bind:key="'product_slider' + index"
            >
                <a
                    :href="product.link"
                    class="col-span-1 flex flex-col shadow-xp rounded border border-xp-light-grey group block_container"
                >
                    <div class="img-container">
                        <img
                            class="object-contain object-center w-full h-60"
                            :src="product.image"
                            alt=""
                        />
                    </div>
                    <h3 class="text-xl font-bold tracking-wider px-6 py-4">
                        {{ product.heading }}
                    </h3>

                    <div class="flex justify-end mt-auto lg:pt-7">
                        <div
                            class="group inline-flex items-center gap-3 px-6 py-4 text-black hover:text-xp-electron-green"
                        >
                            <svg class="shrink-0 group-hover:translate-x-3 transition-transform text-black hover:text-xp-electron-green" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path class="group-hover:text-xp-electron-green" d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" />
                                <path class="group-hover:text-xp-electron-green" d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" />
                            </svg>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="flex items-center mt-8 gap-8">
            <button @click="slider.prev()" class="shrink-0 md:px-6 p-3">
                <svg
                    width="38"
                    height="13"
                    viewBox="0 0 38 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.67969 1.6998L1.63969 6.58233L6.67969 11.4648"
                        stroke="black"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2.60037 6.56003L36.4404 6.56006"
                        stroke="black"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </button>
            <div class="flex-1 flex items-center justify-center space-x-2">
                <button
                    v-for="(_slide, idx) in dotHelper"
                    @click="slider.moveToIdx(idx)"
                    class="block w-5 lg:w-16 h-[2px] transition-colors"
                    :class="{
                        'bg-xp-lilac': current === idx,
                        'bg-xp-carbon/20': current !== idx,
                    }"
                    :key="idx"
                ></button>
            </div>
            <button @click="slider.next()" class="shrink-0 md:px-6 p-3">
                <svg
                    width="39"
                    height="13"
                    viewBox="0 0 39 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M31.3398 11.3002L36.3798 6.41767L31.3398 1.53516"
                        stroke="black"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M35.4192 6.43997L1.5791 6.43994"
                        stroke="black"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";

export default {
    name: "ProductSlider",
    props: {
        products: {
            required: true,
            type: Array,
        },
    },
    computed: {
        dotHelper() {
            return this.slider
                ? [...Array(this.slider.track.details.slides.length).keys()]
                : [];
        },
    },
    data() {
        return {
            current: 0,
            slider: null,
        };
    },
    mounted() {
        this.slider = new KeenSlider(this.$refs.slider, {
            loop: true,
            slides: {
                perView: 1.2,
                spacing: 2,
            },
            breakpoints: {
                "(min-width: 1024px)": {
                    slides: {
                        perView: 3,
                        spacing: 14,
                    },
                },
                "(min-width: 1280px)": {
                    slides: {
                        perView: 4,
                        spacing: 24,
                    },
                },
            },
            initial: this.current,
            slideChanged: (s) => {
                this.current = s.track.details.rel;
            },
        });
    },
    beforeDestroy() {
        if (this.slider) this.slider.destroy();
    },
};
</script>
